var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.fetchingCustomNotifications
        ? _c("pickstar-loading", { staticClass: "m-t-lg" })
        : _c("div", { staticClass: "container-fluid" }, [
            _c(
              "div",
              { staticClass: "dashboard-block onesignal-list" },
              [
                _vm.haveNoCustomNotifications
                  ? _c("no-results", [
                      _c("div", [
                        _vm._v("There are no previous one signal messages."),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "item-detail" },
                  _vm._l(_vm.notifications, function (notification, index) {
                    return _c("system-custom-notifications-list-item", {
                      key: notification.id,
                      attrs: { index: index, notification: notification },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "bottom" } }),
                _vm._v(" "),
                _c(
                  "lazy-loading",
                  {
                    ref: "lazyLoading",
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loading,
                      "reached-bottom":
                        _vm.handleGetNextCustomNotificationsCallback,
                    },
                  },
                  [
                    _c("pickstar-loading", {
                      attrs: { slot: "loading" },
                      slot: "loading",
                    }),
                    _vm._v(" "),
                    _c("span", {
                      attrs: { slot: "finished" },
                      slot: "finished",
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Sent Notifications")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }